import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

interface SubsectionConfig {
  subsectionTitle: string;
  toggleField: {
    fieldName: string;
    fieldLabel: string;
    defaultValue?: boolean;
  };
  fields: {
    fieldName: string;
    fieldType: string;
    fieldLabel: string;
    placeholder?: string;
    options?: any[];
    value?: any;
    defaultValue?: any;
    required?: boolean;
    min?: number;
    max?: number;
    step?: number;
    conditional?: {
      dependsOn: string;
      showWhen: any;
    };
  }[];
}

interface TabField {
  fieldName: string;
  fieldType: string;
  fieldLabel: string;
  placeholder?: string;
  options?: any[];
  value?: any;
  defaultValue?: any;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  fullWidth?: boolean;
  decimalSupport?: boolean;
  conditional?: {
    dependsOn: string;
    showWhen: any;
  };
  subsection?: SubsectionConfig; // For subsection field type
}

interface TabSection {
  type: string;
  sectionTitle?: string;
  fields: TabField[];
}

@Component({
    selector: "app-sections",
    templateUrl: "./sections.component.html",
    styleUrls: ["./sections.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionsComponent {
  @Input() section: TabSection;
  @Input() formGroup!: UntypedFormGroup;
  @Input() disabled: boolean = false;
  @Output() fieldChange = new EventEmitter<{ field: string; value: any }>();

  getFormControl(fieldName: string) {
    return this.formGroup ? this.formGroup.get(fieldName) : null;
  }

  shouldShowField(field: any): boolean {
    if (!field.conditional) return true;
    // Get value from FormGroup instead of local formData
    const dependentControl = this.formGroup.get(field.conditional.dependsOn);
    const dependentValue = dependentControl.value;

    return dependentValue === field.conditional.showWhen;
  }

  /**
   * Handle field value changes
   * @param fieldName - Name of the field
   * @param value - New value
   */
  onFieldChange(fieldName: string, value: any) {
    if (this.formGroup && this.formGroup.get(fieldName)) {
      this.formGroup.get(fieldName).setValue(value);
    }
    this.fieldChange.emit({ field: fieldName, value });
  }
}
